require('jquery');

var presented = 0;

/**
 * Presents a .presentable jQuery element.
 * @param element
 * @param done
 */
export function presentElement(element, done = null)
{
	element.classList.remove('presentable', 'sequential');
	element.classList.add('is-presenting');
	for(let i = 0; i < element.classList.length; i++)
	{
		let className = element.classList[i];
		if (className.indexOf('present-') === 0) {
			element.classList.remove(className);
			--i;
		}
	}

	(function(done)
	{
		this.classList.remove('is-presenting');
		if (done)
			done(this);
	}).after(750, element, [ done ]);
}

function afterPresentation(complete)
{
	document.addEventListener('presented', complete);
}

function onPresented()
{
	if (--presented === 0)
		document.dispatchEvent(new Event('presented'));
}

export function presentAll(context, delay = 150)
{
	let presentables = $('.presentable', context)
		.not('.present-manual');

	let count = presentables.not('.sequential')
		.each(function()
		{
			presented++;
			presentElement(this, onPresented);
		}).length;

	count += presentables.filter('.sequential')
		.get()
		.delayEach(delay, function()
		{
			presented++;
			presentElement(this, onPresented);
		})
		.length;

	if (count === 0)
		document.dispatchEvent(new Event('presented'));
}

HTMLElement.prototype.present = function()
{
	presentElement(this);
};

$(function()
{
	presentAll();
});

window.presentElement = presentElement;
window.presentAll = presentAll;
